import React, {useEffect, useState} from 'react';
import GoogleLogin from 'react-google-login';
import {useTranslation} from 'react-i18next';
import {google_client_id, linkedInScope, linkedIn_client_id} from '../../config';
import * as authAction from '../../store/actions/auth.action';
import {checkAppraisalRouter, checkIsUserPage, customMenus, getCodeFromWindowURL, storeToken} from '../../utils/handler';

let lastCode: any;
interface ChildProps {
  onSuccess: (loginResponse: string) => void;
  disabled?: boolean
}
interface APIResponseType {
  type?: string;
  code: number;
  access_token?: string;
}
interface EventType {
  data: APIResponseType;
}
// interface SocialResponseType {
//     profileObj: {
//         email: string,
//         provider_id: string,
//         provider_name: string,
//         image: string,
//         name: string, googleId: string, imageUrl: string
//     }
// }

export const googleOneTabLogin = async (data: {name: string, picture: string, email: string}) => {
  if (data) {
    let payload = {
      email: data.email,
      provider_id: customMenus.oneTabLogin,
      provider_name: 'Google',
      image: data.picture,
      name: data.name,
      roleType: checkIsUserPage(),
    };
    if (checkAppraisalRouter()) {
      authAction.oneTabLogin(payload)
    } else {
      let res = await authAction.socialLogin(payload);
      if (res) {
        storeToken(res)
        // console.log('res', res)
      }
    }
  }
}

export const GoogleLoginComponent: React.FC<ChildProps> = ({onSuccess, disabled}) => {
  const {t} = useTranslation();
  const [showLoader, setShowLoader] = useState(false);
  const [LI_BTN_Loader, setLI_BTN_Loader] = useState(false);

  const handlePostMessage = (event: EventType) => {
    if (event && event.data && event.data.type === 'code') {
      const {code} = event.data;
      handleSocialLogin({data: {code}});
    }
  };
  useEffect(() => {
    if (window.opener && window.opener !== window) {
      const code = getCodeFromWindowURL(window.location.href);
      window.opener.postMessage({type: 'code', code: code}, '*');
      if (code) {
        window.close();
      }
    }

    window.addEventListener('message', handlePostMessage);
    return () => {
      window.removeEventListener('message', handlePostMessage);
      lastCode = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const responseGoogle = async (data: any) => {
    if (data.profileObj) {
      let profile = data.profileObj;
      let payload = {
        email: profile.email,
        provider_id: profile.googleId,
        provider_name: 'Google',
        image: profile.imageUrl,
        name: profile.name,
        roleType: checkIsUserPage(),
      };
      setShowLoader(true);
      let res: string = await authAction.socialLogin(payload);
      if (res) {
        onSuccess(res);
      }
      setShowLoader(false);
    }
  };

  const handleSocialLogin = async ({data}: EventType) => {
    let code = data.code || data.access_token;

    if (lastCode !== code) {
      setLI_BTN_Loader(true);
      lastCode = code;
      let res = await authAction.linkedInLogin({code, roleType: checkIsUserPage()});
      if (res) {
        onSuccess(res);
      }
      setLI_BTN_Loader(false);
    }
  };

  const showLinkedInPopup = () => {
    let redirectURL = window.location.origin; // redirect_URL
    const oauthURL = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${linkedIn_client_id}&scope=${linkedInScope}&state=12345&redirect_uri=${redirectURL}`;

    const width = 450,
      height = 730,
      left = window.screen.width / 2 - width / 2,
      top = window.screen.height / 2 - height / 2;
    let linkedInPopupConfig = `menubar=no,location=no,resizable=no,scrollbars=no,status=no,width=${width},height=${height}',top=${top},left=${left}`;
    window.open(oauthURL, '', linkedInPopupConfig);
  };
  return (
    <>
      {' '}
      <GoogleLogin
        clientId={google_client_id}
        icon={false}
        onSuccess={responseGoogle}
        className={'google-icon '}
        disabled={disabled || showLoader}
        render={(renderProps) => (
          <button onClick={renderProps.onClick} disabled={renderProps.disabled || showLoader} className={'btn btn-outline-danger google-btn  no-radius'}>
            {showLoader ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : <i className="fab fa-google-plus-g  fs-20 "></i>} {t('Google')}
          </button>
        )}
      ></GoogleLogin>
      <button className={'btn btn-outline-primary no-radius '} disabled={disabled || LI_BTN_Loader} onClick={showLinkedInPopup}>
        {LI_BTN_Loader ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : <i className="fab fa-linkedin"></i>} {t('LinkedIn')}
      </button>
    </>
  );
};
